export var LAYOUT_EXPANDABLE = 'layout--expandable';
export var LAYOUT_COLLAPSE_ALL = 'layout--collapse-all';
export var ALERT_SHOW = 'ALERT_SHOW';
export var ALERT_HIDE = 'ALERT_HIDE';
export var SEND_DATA_FAILURE = 'SEND_DATA_FAILURE';
export var TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';
export var TOGGLE_NAVBAR_DROPDOWN = 'TOGGLE_NAVBAR_DROPDOWN';
export var RESET_LAYOUT = 'RESET_LAYOUT';
export var EMAIL_LWK_GO_TO_INITIAL_STATE = 'EMAIL_LWK_GO_TO_INITIAL_STATE';
export var EMAIL_LWK_GO_TO_SUCCESS_STATE = 'EMAIL_LWK_GO_TO_SUCCESS_STATE';
export var EMAIL_LWK_GO_TO_FAILURE_STATE = 'EMAIL_LWK_GO_TO_FAILURE_STATE';
export var SET_FLASH = 'SET_FLASH';
